import { CardPopover } from "../../QuoteCards/QuoteCard/InfoModal/CardPopover";

export const CancelAnytime = ({ eventTrackerCallback }: CancelAnytimeProps) => {
  return (
    <div className="mobius-cancel-anytime__popover-wrapper">
      <CardPopover
        toggleText="Cancel anytime"
        body="You can easily cancel your insurance policy at any time during the policy period. Please note that penalties may apply."
        onOpen={eventTrackerCallback}
      />
    </div>
  );
};

export interface CancelAnytimeProps {
  eventTrackerCallback?: () => void;
}

CancelAnytime.displayName = "CancelAnytime";
